import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Alert, Box, Button, CircularProgress, Container, Paper, Typography } from '@mui/material';
import AndroidIcon from '@mui/icons-material/Android';
import DownloadIcon from '@mui/icons-material/Download';
import { QRCodeSVG } from 'qrcode.react';
import api from './api/api';
import { LegalLinks } from './LegalDocsPage';

export const ANDROID_PAGE_URL = 'https://prokatprost.ru/app';

export default function AndroidDownloadPage() {
  const [release, setRelease] = useState(null);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let active = true;
    setLoading(true); setFailed(false);
    api.get('/public/android-release', { skipLoading: true }).then(({ data }) => {
      if (active) setRelease(data);
    }).catch(() => { if (active) { setRelease(null); setFailed(true); } })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [retry]);
  return <Container maxWidth="md" sx={{ py: { xs: 3, md: 7 } }}>
    <Button component={RouterLink} to="/" sx={{ mb: 3 }}>← На сайт ПрокатПрост</Button>
    <Paper variant="outlined" sx={{ p: { xs: 3, md: 5 }, borderRadius: 4, bgcolor: '#fffdfa' }}>
      <AndroidIcon sx={{ fontSize: 44, color: '#21a038', mb: 2 }} />
      <Typography component="h1" variant="h4" fontWeight={700}>ПрокатПрост для Android</Typography>
      <Typography color="text.secondary" sx={{ mt: 2, mb: 4 }}>
        Выбирайте товары, общайтесь с пунктом проката и продлевайте аренду в приложении.
        Вход — через Сбер ID или по звонку, если вы уже оформлялись в нашем пункте проката.
      </Typography>
      {loading ? <CircularProgress aria-label="Проверяем доступность приложения" /> : failed
        ? <Alert severity="warning" action={<Button onClick={() => setRetry(value => value + 1)}>Повторить</Button>}>
          Не удалось проверить доступность приложения. Попробуйте ещё раз.
        </Alert>
        : release?.available === true ? <Box sx={{ display: 'flex', gap: 5, alignItems: 'center', flexWrap: 'wrap' }}>
          <Box sx={{ flex: '1 1 240px' }}>
            <Button variant="contained" size="large" href="/api/public/android-release/apk" startIcon={<DownloadIcon />}>
              Скачать приложение
            </Button>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              Версия {release.version} · {(release.size / 1024 / 1024).toFixed(1)} МБ · Android {release.min_android} и новее
            </Typography>
          </Box>
          <Box sx={{ textAlign: 'center', mx: 'auto' }}>
            <Box sx={{ bgcolor: 'white', p: 2, borderRadius: 2, display: 'inline-flex' }}>
              <QRCodeSVG value={ANDROID_PAGE_URL} size={156} level="M" title="Открыть страницу приложения на телефоне" />
            </Box>
            <Typography variant="body2" color="text.secondary">Откройте QR-код камерой телефона</Typography>
          </Box>
        </Box> : <Alert severity="info">Приложение готовится к выпуску. Пока оформляйте аренду на сайте.</Alert>}
      {!loading && release?.available === true && <Box sx={{ mt: 5 }}>
        <Typography component="h2" variant="h6" fontWeight={700}>Как установить</Typography>
        <Box component="ol" sx={{ pl: 2.5, lineHeight: 1.9 }}>
          <li>Скачайте APK и откройте загруженный файл на телефоне.</li>
          <li>Если Android попросит, разрешите установку из браузера и нажмите «Установить».</li>
          <li>Откройте ПрокатПрост. Войдите через Сбер ID или подтвердите звонком телефон из вашей карточки клиента.</li>
        </Box>
        <Typography variant="body2" color="text.secondary">При обновлении установите новый APK поверх прежнего приложения.</Typography>
      </Box>}
      <Button component={RouterLink} to="/" sx={{ mt: 3 }}>Перейти в каталог</Button>
    </Paper>
    <Box sx={{ mt: 4 }}><LegalLinks /></Box>
  </Container>;
}
